// Precio por cantidad (tramos). Ejemplo: base $1.000, desde 3 → $900, desde 6 → $850.
// El tramo alcanzado se aplica a TODAS las unidades de la línea.

/** Ordena y limpia los tramos: [{desde, precio}] con desde >= 2 y precio > 0. */
export function normalizeTiers(tiers) {
  return (tiers || [])
    .map((t) => ({ desde: Number(t.desde), precio: Number(t.precio) }))
    .filter((t) => t.desde >= 2 && t.precio > 0)
    .sort((a, b) => a.desde - b.desde);
}

/** Precio unitario que corresponde a `cantidad`. Sin tramos devuelve el precio base. */
export function tierPrice(base, tiers, cantidad) {
  const list = normalizeTiers(tiers);
  let precio = Number(base) || 0;
  for (const t of list) {
    if (Number(cantidad) >= t.desde) precio = t.precio;
  }
  return precio;
}

/** Texto corto para mostrar los tramos: "3+ $900 · 6+ $850". */
export function tiersLabel(tiers, clpFn) {
  const list = normalizeTiers(tiers);
  if (!list.length) return "";
  return list.map((t) => `${t.desde}+ ${clpFn ? clpFn(t.precio) : t.precio}`).join(" · ");
}
